const RegistrationStatusEnum = Object.freeze({
    COMPLETE: 'COMPLETE',
    FAILED_CLASSIFICATION: 'FAILED_CLASSIFICATION',
    PENDING: 'PENDING'
});

export default RegistrationStatusEnum;
